const STORAGE_CONSTANTS = {
  TOKEN_KEY: 'CONFER_SESSION_TOKEN_KEY',
  HCP_KEY: 'HAS_VERIFIED_HCP',
  ISI_KEY: 'HAS_VERIFIED_ISI',
};

export default STORAGE_CONSTANTS;
